
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[version]/apis/[package]/references/[operation]",
      function () {
        return require("private-next-pages/docs/[version]/apis/[package]/references/[operation].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[version]/apis/[package]/references/[operation]"])
      });
    }
  